module.exports = __webpack_public_path__ + "static/media/accesoWeb.0018ce7d.jpg";